import { Card, Typography } from "antd";

const { Text } = Typography;

function Metric({ label, value }) {
  return (
    <div style={{ minWidth: 120 }}>
      <div style={{ fontSize: 24, fontWeight: 600, lineHeight: 1.2 }}>
        {value}
      </div>
      <Text type="secondary">{label}</Text>
    </div>
  );
}

export default function DayKpis({ kpis }) {
  return (
    <Card size="small">
      <div style={{ display: "flex", gap: 32, flexWrap: "wrap" }}>
        <Metric label="atendimentos" value={kpis.attendances} />
        <Metric label="vendas" value={kpis.sales} />
        <Metric label="não-vendas" value={kpis.no_sales} />
        <Metric
          label="conversão"
          value={kpis.conversion_pct === null ? "—" : `${kpis.conversion_pct}%`}
        />
        <Metric label="pendentes" value={kpis.pending} />
      </div>
    </Card>
  );
}
